export default "__VITE_ASSET__ByWY4xEb__"